import React from 'react';
import { connect } from 'react-redux';
import { evolve, add } from 'ramda';
import { getSelectedId, toggleChart } from '../reducers/chart';

class ChartState extends React.Component {
  state = {
    hoveredId: null,
    hoveredDate: null,
    tooltipProps: null,
    scrollX: 0,
    tooltipXOffset: 0,
  };

  setHovered = (id, date, prevId = null, tooltip = null) => {
    this.setState(
      state =>
        prevId !== null && prevId !== state.hoveredId
          ? {}
          : {
              hoveredId: id,
              hoveredDate: date,
              tooltipProps: tooltip,
            },
    );
  };

  setScrollX = x => {
    this.setState({
      scrollX: x,
    });
  };

  setTooltipXOffset = x => {
    this.setState({
      tooltipXOffset: x,
    });
  };

  render() {
    return this.props.children({
      ...this.state,
      tooltipProps:
        this.state.tooltipProps === null
          ? null
          : evolve(
              { x: add(this.state.tooltipXOffset - this.state.scrollX) },
              this.state.tooltipProps,
            ),
      setScrollX: this.setScrollX,
      selectedId: this.props.selectedId,
      setSelected: this.props.setSelected,
      setHovered: this.setHovered,
      setTooltipXOffset: this.setTooltipXOffset,
    });
  }
}

export default connect(
  state => ({
    selectedId: getSelectedId(state),
  }),
  {
    setSelected: toggleChart,
  },
)(ChartState);



// WEBPACK FOOTER //
// ./src/components/ChartSelection.jsx